module.exports = __webpack_public_path__ + "cf7997481030b59761cf87cd9e9dedac.png";